/* eslint-disable */

import React, { useState, useEffect } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { renderReact } from "../src/lib/ssrHydrator";
import ja from "date-fns/locale/ja";

registerLocale("ja", ja);

function CompanyPCDateSelector() {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    const startDateInput = document.getElementById("jsStartDate");
    const event = new Event("input", { bubbles: true });
    startDateInput.dispatchEvent(event);
  }, [startDate]);

  useEffect(() => {
    const endDateInput = document.getElementById("jsEndDate");
    const event = new Event("input", { bubbles: true });
    endDateInput.dispatchEvent(event);
  }, [endDate]);

  return (
    <div className="selectConditions searchList isActivityDate">
      <DatePicker
        dateFormat="yyyy-MM-dd"
        selected={startDate}
        onChange={(date) => setStartDate(date)}
        placeholderText="活動日程の期間選択"
        locale="ja"
        name="start_date"
        id="jsStartDate"
        className="startDate"
        autoComplete="off"
      />
      <span>〜</span>
      <DatePicker
        dateFormat="yyyy-MM-dd"
        selected={endDate}
        onChange={(date) => setEndDate(date)}
        placeholderText="活動日程の期間選択"
        locale="ja"
        name="end_date"
        id="jsEndDate"
        className="endDate"
        autoComplete="off"
      />
    </div>
  );
}

export default renderReact("CompanyPCDateSelector", CompanyPCDateSelector);
